
import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

import './AdminHeroManagement.css';

function AdminHeroManagement() {
  const [heroImageUrl, setHeroImageUrl] = useState('');
  const [heroVideoUrlMobile, setHeroVideoUrlMobile] = useState('');
  const [heroVideoUrlDesktop, setHeroVideoUrlDesktop] = useState('');
  const [newImage, setNewImage] = useState(null);
  const [newVideoMobile, setNewVideoMobile] = useState(null);
  const [newVideoDesktop, setNewVideoDesktop] = useState(null);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    const fetchHeroContent = async () => {
      const heroDocRef = doc(db, 'siteContent', 'hero');
      const heroDocSnap = await getDoc(heroDocRef);
      if (heroDocSnap.exists()) {
        const data = heroDocSnap.data();
        setHeroImageUrl(data.imageUrl || '');
        setHeroVideoUrlMobile(data.videoUrlMobile || '');
        setHeroVideoUrlDesktop(data.videoUrlDesktop || '');
      }
    };
    fetchHeroContent();
  }, []);

  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];
    if (file) {
      switch (fileType) {
        case 'image':
          setNewImage(file);
          break;
        case 'videoMobile':
          setNewVideoMobile(file);
          break;
        case 'videoDesktop':
          setNewVideoDesktop(file);
          break;
        default:
          break;
      }
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setFeedback('');
    const heroDocRef = doc(db, 'siteContent', 'hero');
    let newUrls = {};

    try {
      if (newImage) {
        const imageRef = ref(storage, `hero/${newImage.name}`);
        await uploadBytes(imageRef, newImage);
        newUrls.imageUrl = await getDownloadURL(imageRef);
      }
      if (newVideoMobile) {
        const videoMobileRef = ref(storage, `hero/${newVideoMobile.name}`);
        await uploadBytes(videoMobileRef, newVideoMobile);
        newUrls.videoUrlMobile = await getDownloadURL(videoMobileRef);
      }
      if (newVideoDesktop) {
        const videoDesktopRef = ref(storage, `hero/${newVideoDesktop.name}`);
        await uploadBytes(videoDesktopRef, newVideoDesktop);
        newUrls.videoUrlDesktop = await getDownloadURL(videoDesktopRef);
      }

      await setDoc(heroDocRef, newUrls, { merge: true });

      if (newUrls.imageUrl) setHeroImageUrl(newUrls.imageUrl);
      if (newUrls.videoUrlMobile) setHeroVideoUrlMobile(newUrls.videoUrlMobile);
      if (newUrls.videoUrlDesktop) setHeroVideoUrlDesktop(newUrls.videoUrlDesktop);

      setNewImage(null);
      setNewVideoMobile(null);
      setNewVideoDesktop(null);
      setFeedback('Contenido del hero actualizado con éxito.');
    } catch (error) {
      console.error("Error updating hero content: ", error);
      setFeedback('Error al actualizar el contenido del hero.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-hero-management">
      <h2>Gestionar Contenido del Hero</h2>
      {feedback && <p className="feedback">{feedback}</p>}

      <div className="hero-sections-container">
        <div className="hero-section">
          <h3>Imagen de Fondo (Fallback)</h3>
          {heroImageUrl && <img src={heroImageUrl} alt="Hero" />}
          <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, 'image')} />
        </div>

        <div className="hero-section">
          <h3>Video para Móviles</h3>
          {heroVideoUrlMobile && <video src={heroVideoUrlMobile} controls />}
          <input type="file" accept="video/*" onChange={(e) => handleFileChange(e, 'videoMobile')} />
        </div>

        <div className="hero-section">
          <h3>Video para Desktop</h3>
          {heroVideoUrlDesktop && <video src={heroVideoUrlDesktop} controls />}
          <input type="file" accept="video/*" onChange={(e) => handleFileChange(e, 'videoDesktop')} />
        </div>
      </div>

      <button onClick={handleSave} disabled={loading}>
        {loading ? 'Guardando...' : 'Guardar Cambios'}
      </button>
    </div>
  );
}

export default AdminHeroManagement;
